export default __webpack_public_path__ + "static/media/Sign-Blue-24x24.cc287fcd.svg";